import React from 'react';

import { StyleUtil } from '../../util';
import classNames from './EABDVerticalSpacing.module.scss';

export enum VerticalSpacingType {
  X05 = 'X05',
  X1 = 'X1',
  X2 = 'X2',
  X3 = 'X3',
}

export interface VerticalSpacingProps {
  type: VerticalSpacingType;
}

export const VerticalSpacing = React.memo<VerticalSpacingProps>((props) => {
  const { type } = props;

  const ContainerStyles = React.useMemo(() => {
    const containerStyles: string[] = [classNames.container];

    switch (type) {
      case VerticalSpacingType.X05:
        containerStyles.push(classNames.x05);
        break;
      case VerticalSpacingType.X1:
        containerStyles.push(classNames.x1);
        break;
      case VerticalSpacingType.X2:
        containerStyles.push(classNames.x2);
        break;
      case VerticalSpacingType.X3:
        containerStyles.push(classNames.x3);
        break;
    }

    return StyleUtil.mergeClassNames(containerStyles);
  }, [type]);

  return <div className={ContainerStyles}></div>;
});
